import { apiCall } from '../../utils/restclient'
import { LOGIN, LOGIN_SUCCESS, LOGIN_ERROR } from './HomeConstants'
import env from '../../env.json'
import { generateMqttRandomClientId } from 'utils/generateMqttRandomClientId'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const login = (loginObj) => {
  const endpoint = 'api/v1/auth/login'
  const action = {
    type: LOGIN,
    payload: { endpoint, body: { ...loginObj } },
  }
  const mqttRandomClientId = generateMqttRandomClientId()
  const telemetryConfig = {
    publicToken: env.stytchToken,
    submitURL: 'auth-dfp.quick.md',
  }

  if (typeof window.GetTelemetryID === 'function') {
    // Wrap inside .then() so synchronous throws from GetTelemetryID land in .catch().
    Promise.resolve()
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      .then(() => window.GetTelemetryID(telemetryConfig))
      .then((telemetryId) => {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        apiCall(endpoint, 'POST', null, JSON.stringify({ ...action.payload.body, TelemetryId: telemetryId }), {
          success: LOGIN_SUCCESS,
          error: LOGIN_ERROR,
          extraData: { mqttRandomClientId },
        })
      })
      .catch(() => {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        apiCall(endpoint, 'POST', null, JSON.stringify(action.payload.body), {
          success: LOGIN_SUCCESS,
          error: LOGIN_ERROR,
          extraData: { mqttRandomClientId },
        })
      })
  } else {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(action.payload.body), {
      success: LOGIN_SUCCESS,
      error: LOGIN_ERROR,
      extraData: { mqttRandomClientId },
    })
  }

  return action
}
